import Service from "../Service";

const resource = "Requirement/";

export default {

    pagination(parameters, requestID) {
        return Service.post(resource + "paginationH", parameters, {
            params: { requestID: requestID },
        });
    },
};